import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-button-cancel-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Cancel ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_button, {
      tertiary: "",
      caution: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel-clicked')))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}